var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webphone-call-history" }, [
    _c("div", { staticClass: "history-header" }, [
      _c("h4", [_vm._v("Arama Geçmişi")]),
      _vm._v(" "),
      _vm.callHistory.length > 0
        ? _c(
            "button",
            {
              staticClass: "clear-btn",
              on: {
                click: function ($event) {
                  return _vm.$emit("clear-history")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("delete_sweep"),
              ]),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.callHistory.length === 0
      ? _c("div", { staticClass: "empty-state" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "empty-text" }, [
            _vm._v("Henüz arama geçmişi yok"),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "history-list" },
          _vm._l(_vm.callHistory, function (call, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "history-item",
                on: {
                  click: function ($event) {
                    return _vm.$emit("call", call)
                  },
                },
              },
              [
                _c("div", { staticClass: "call-icon" }, [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: _vm.getCallIconClass(call.type),
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getCallIcon(call.type)) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "call-info" }, [
                  _c("div", { staticClass: "call-number" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(call.name || call.number) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "call-details" }, [
                    _c("span", { staticClass: "call-date" }, [
                      _vm._v(_vm._s(_vm.formatDate(call.date))),
                    ]),
                    _vm._v(" "),
                    call.duration > 0
                      ? _c("span", { staticClass: "call-duration" }, [
                          _vm._v(
                            "\n                        • " +
                              _vm._s(_vm.formatDuration(call.duration)) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "call-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "action-btn info-btn",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.showCallInfo(call)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("info"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "action-btn call-btn",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("call", call)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("call"),
                      ]),
                    ]
                  ),
                ]),
              ]
            )
          }),
          0
        ),
    _vm._v(" "),
    _vm.selectedCall
      ? _c(
          "div",
          {
            staticClass: "call-info-modal",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                _vm.selectedCall = null
              },
            },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h4", [_vm._v("Arama Detayları")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    on: {
                      click: function ($event) {
                        _vm.selectedCall = null
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("Numara:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.selectedCall.number)),
                  ]),
                ]),
                _vm._v(" "),
                _vm.selectedCall.name
                  ? _c("div", { staticClass: "info-row" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("İsim:")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selectedCall.name)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("Tür:")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "value call-type",
                      class: _vm.selectedCall.type,
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.getCallTypeText(_vm.selectedCall.type)) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("Tarih:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.formatFullDate(_vm.selectedCall.date))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("Süre:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(_vm.formatDuration(_vm.selectedCall.duration))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "cancel-btn",
                    on: {
                      click: function ($event) {
                        _vm.selectedCall = null
                      },
                    },
                  },
                  [_vm._v("\n                    Kapat\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "call-btn", on: { click: _vm.callFromModal } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("call"),
                    ]),
                    _vm._v("\n                    Ara\n                "),
                  ]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("history")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }